import React from "react";
import classNames from "classnames";
import "./index.less";

const PREFIX = "CommonModal";

interface IProps {
  visible: boolean;
  animation: string;
  style?: object;
  onClose: Function;
  className?: string;
}

interface IState {
  modalVisible: boolean;
  modalClassname: string;
  contentClassname: string;
}

class Modal extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    const { visible } = this.props;

    this.state = {
      modalVisible: visible,
      modalClassname: "",
      contentClassname: "",
    };
  }

  componentDidUpdate(prevProps: IProps) {
    const { visible, animation } = this.props;
    /* 外部props.visible变更时 */
    if (visible !== prevProps.visible) {
      if (visible) {
        // 显示
        this.setState({ modalVisible: true });
        this.switchModalClasses(true);
      } else {
        // 隐藏
        if (animation == "none") {
          // 直接设为不可见
          this.setState({ modalVisible: false });
        } else {
          // 执行动画
          this.switchModalClasses(false);
          // 等待动画执行完，才真的卸载（会有bug）
          setTimeout(() => {
            this.setState({ modalVisible: false });
          }, 500);
        }
      }
    }
  }

  /* 关闭弹窗 */
  handleClose = () => {
    const { onClose } = this.props;
    // 通知外部，将props.visible设置为false
    onClose();
  };

  // 切换动画类
  switchModalClasses = (visible: boolean) => {
    const { modalClassname, contentClassname } = this.getClassNames(visible);
    this.setState({ modalClassname, contentClassname });
  };

  // 获取动画类
  getClassNames = (
    modalVisible: boolean
  ): {
    modalClassname: string;
    contentClassname: string;
  } => {
    const { animation } = this.props;
    return {
      modalClassname: classNames("animated", {
        fadeIn: modalVisible,
        fadeOut: !modalVisible,
        noAnimate: animation === "none",
      }),
      contentClassname: classNames("animated", {
        slideInUp: animation == "slide" && modalVisible,
        fadeIn: animation == "fade" && modalVisible,
        fadeOut: animation == "fade" && !modalVisible,
        slideOutDown: animation == "slide" && !modalVisible,
        noAnimate: animation === "none",
      }),
    };
  };

  render() {
    if (!this.state.modalVisible) return null;
    const { className } = this.props;
    const { modalClassname, contentClassname } = this.state;
    return (
      <div className={classNames(PREFIX, className)}>
        <div
          className={classNames(modalClassname, `${PREFIX}-layer`)}
          onClick={this.handleClose}
        />
        <div
          style={{ ...this.props.style }}
          className={classNames(contentClassname, `${PREFIX}-body`)}
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default Modal;
